export const ABC_CATEGORIES_FILTER_ID = 'abc_categories';
export const ABC_CATEGORIES_FILTER_TITLE = 'ABC-анализ';
